import reportStoreMutations from '@/state/reportStore/reportStoreMutations'
import reportStoreActions from '@/state/reportStore/reportStoreActions'
import reportStoreDefaultState from '@/state/reportStore/reportStoreDefaultState'

let state = reportStoreDefaultState()

export const reportStore = {
  namespaced: true,
  state,
  mutations: reportStoreMutations,
  actions: reportStoreActions
}
